import { z } from 'zod';

export const userAffiliateCodeResDto = z.object({
  affiliateCode: z.string().optional(),
});
export type UserAffiliateCodeResDto = z.infer<typeof userAffiliateCodeResDto>;
